import { crmRequest } from '../http'
import type { Dashboard, Part, Scope } from './types'

/** `GET /crm/dashboard`; without `scope` the server picks Mijn or Team and says which. */
export function getDashboard(options: { scope?: Scope; weeks?: number; parts?: readonly Part[] } = {}): Promise<Dashboard> {
  const params = new URLSearchParams()
  if (options.scope) params.set('scope', options.scope)
  params.set('weeks', String(options.weeks ?? 4))
  if (options.parts && options.parts.length > 0) params.set('parts', options.parts.join(','))
  return crmRequest(`/dashboard?${params.toString()}`)
}
